export const addressValidationErrorCode = {
    "AE01":"Please check the postal code.",
    "AE02":"Please verify that you have the DELIVERY STREET ADDRESS in the FIRST line and any PROJECT NAME in the SECOND line.",
    "AE03":"Please check the street address.",
    "AE05":"Please check the street address.",
    "AE08":"Please check the unit number.",
    "AE09":"Please check the unit number.",
    "AE10":"Please check the street address.",
    "AE11":"Please verify that you have the DELIVERY STREET ADDRESS in the FIRST line and any PROJECT NAME in the SECOND line.",
    "AE12":"Please check the street address.",
    "AE13":"Please check the street address.",
    "AE14":"Please check the street address.",
    "AE17":"Please check the street address and unit number."
    }


// WEBPACK FOOTER //
// ./src/App/redux/util/addressValidationErrorCodes.js